import type { Envelope } from "../types";
import { fromBase64 } from "./crypto-core";

const decoder = new TextDecoder();

function envelope(value: unknown): Envelope | null {
  if (!value || typeof value !== "object") return null;
  const candidate = value as Partial<Envelope>;
  return typeof candidate.iv === "string" && candidate.iv.length > 0
    && typeof candidate.ciphertext === "string" && candidate.ciphertext.length > 0
    ? { iv: candidate.iv, ciphertext: candidate.ciphertext }
    : null;
}

export function decodeBlobChunk(value: unknown, index: number): Envelope {
  const direct = envelope(value);
  if (direct) return direct;

  const wrapped = value && typeof value === "object" ? (value as { ciphertext?: unknown }).ciphertext : undefined;
  if (typeof wrapped === "string" && wrapped.length > 0) {
    try {
      const decoded = envelope(JSON.parse(decoder.decode(fromBase64(wrapped))));
      if (decoded) return decoded;
    } catch { /* use the actionable error below */ }
  }

  throw new Error(`Encrypted chunk ${index + 1} returned invalid data. Reload the file and try again.`);
}
